import React, { useEffect, useState } from 'react'
import { CaretDownOutlined, CloseCircleOutlined, EditOutlined } from '@ant-design/icons'
import { Button, Tag } from 'antd'
import './RelativeCollapse.scss'
import { IBusinessCustomers, IListBusinessCustomers } from '../../api/business/businessApi'
import { dataGender } from '../../services/data'

interface Props {

  item: IListBusinessCustomers
  show?: boolean
  showControl?: boolean
  className?: string
  handleOpenModalUpdate?: (id: number) => void
  handleOpenModalDele?: (id: number) => void
  onToggle?: () => void
  onDelete?: () => void
  onEdit?: () => void
}

const ItemContact: React.FC<Props> = (props) => {
  const {
    item, show = false, showControl = false, className = '',
    onToggle, onDelete, onEdit, handleOpenModalUpdate, handleOpenModalDele
  } = props

  const [isShow, setIsShow] = useState(true)

  useEffect(() => {
    setIsShow(show)
  }, [show])

  const toggleShow = () => {
    setIsShow(!isShow)

    // if (onToggle) {
    //   onToggle()
    // }
  }


  return (
    <div className={`relative-collapse ${className} ${showControl ? 'relative-collapse-with-control' : ''}`}>
      <div
        className={`relative-collapse__title ${isShow ? 'show' : 'collapsed'}`}
      >
        <div
          className="icon"
          onClick={toggleShow}
        >
          <CaretDownOutlined />
        </div>
        <div
          className="title"
          onClick={toggleShow}
        >
          <span className='font-bold neutral-gray-700'>{item?.username}</span>
          <Tag
            className='rs-tag sunset-orange no-border'
          >Thành viên</Tag>
        </div>
        {
          showControl && (
            <div className="control">
              <Button
                icon={<CloseCircleOutlined />}
                className="rs-button delete"
                onClick={() => handleOpenModalDele?.(Number(item.id))}
              />
              <Button
                icon={<EditOutlined />}
                className="rs-button"
                onClick={() => handleOpenModalUpdate?.(Number(item.id))}
              />
            </div>
          )
        }
      </div>

      <div
        className={`relative-collapse__content ${isShow ? 'show' : 'collapsed'}`}
      >
        <div className="item">
          <div className="item__label">Họ và tên</div>
          <div className="item__value">{item?.username}</div>
        </div>
        <div className="item">
          <div className="item__label">Giới tính</div>
          <div className="item__value">{dataGender[item.gender ?? 0].title}</div>
        </div>
        <div className="item">
          <div className="item__label">Số điện thoại</div>
          <div className="item__value">{item?.phoneBusiness}</div>
        </div>
        <div className="item">
          <div className="item__label">CCCD</div>
          <div className="item__value">{item?.CCCD}</div>
        </div>
        <div className="item">
          <div className="item__label">Sinh nhật</div>
          <div className="item__value">{item?.birthday}</div>
        </div>
        <div className="item">
          <div className="item__label">Nghề nghiệp</div>
          <div className="item__value">{item?.profession}</div>
        </div>
        <div className="item">
          <div className="item__label">Email</div>
          <div className="item__value">{item?.email}</div>
        </div>
        <div className="item">
          <div className="item__label">Địa chỉ</div>
          <div className="item__value">
            {[item?.address, item?.districtTitle, item?.provinceTitle].filter(Boolean).join("-")}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ItemContact
